export default "__VITE_ASSET__C_dcw5Vq__"